module.exports = __webpack_public_path__ + "static/media/icon_filter_active.9e314ed7.svg";